import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import BillingTypeMappingContMain from "presentation/view/container/BillingTypeMapping/BillingTypeMappingContMain";

CommonEntrypoint(<BillingTypeMappingContMain/>)